import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { isMobile } from 'react-device-detect';

const SkeletonMenu = () => (
    <>
        {isMobile && <Skeleton className="skeleton__menu touch" count={17} />}
        {!isMobile
            && (
                <>
                    <Skeleton className="skeleton__menu" count={4} />
                    <hr className="mt-1" />
                    <Skeleton className="skeleton__menu" count={4} />
                    <hr className="mt-1" />
                    <Skeleton className="skeleton__menu" count={4} />
                    <hr className="mt-1" />
                    <Skeleton className="skeleton__menu" count={5} />
                </>
            )}
    </>
);

export default SkeletonMenu;
